<app-auth-layout>
  <app-login-form
    [processing]="processing$ | async"
    [error]="error$ | async"
    (login)="onLogin($event)"
  ></app-login-form>
</app-auth-layout>
